module.exports={
    "reports_addReport": {
        "id": "reports_addReport",
        "eventName": "adicionar_relatório",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório",
        "eventValue": 0
    },
    "reports_addExpense": {
        "id": "reports_addExpense",
        "eventName": "adicionar_despesa",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório",
        "eventValue": 0
    },
    "reports_addRoute": {
        "id": "reports_addRoute",
        "eventName": "adicionar_percurso",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório",
        "eventValue": 0
    },
    "reports_addRouteMap": {
        "id": "reports_addRouteMap",
        "eventName": "adicionar_percurso_mapa",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório",
        "eventValue": 0
    },
    "reportsModal_description": {
        "id": "reportsModal_description",
        "eventName": "descrição_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_costCenter": {
        "id": "reportsModal_costCenter",
        "eventName": "centro_custos_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_advancement": {
        "id": "reportsModal_advancement",
        "eventName": "adiantamento_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_moreOptions": {
        "id": "reportsModal_moreOptions",
        "eventName": "mais_opcoes",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_projects": {
        "id": "reportsModal_projects",
        "eventName": "projetos",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_payment": {
        "id": "reportsModal_payment",
        "eventName": "forma_pagamento",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_observation": {
        "id": "reportsModal_observation",
        "eventName": "observacao",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_save": {
        "id": "reportsModal_save",
        "eventName": "salvar_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reportsModal_cancel": {
        "id": "reportsModal_cancel",
        "eventName": "cancelar_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Ações Principais Relatório | Modal para adicionar novo relatório",
        "eventValue": 0
    },
    "reports_searchFilter": {
        "id": "reports_searchFilter",
        "eventName": "pesquisar_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": 0
    },
    "reports_dateStartFIlter": {
        "id": "reports_dateStartFIlter",
        "eventName": "data_inicio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": 0
    },
    "reports_dateEndFilter": {
        "id": "reports_dateEndFilter",
        "eventName": "data_fim",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": 0
    },
    "reports_status": {
        "id": "reports_status",
        "eventName": "status",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": "{{label}}"
    },
    "reports_costCenterFilter": {
        "id": "reports_costCenterFilter",
        "eventName": "centro_custo",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": "{{label}}"
    },
    "reports_projectFilter": {
        "id": "reports_projectFilter",
        "eventName": "projetos",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": "{{label}}"
    },
    "reports_advancementFilter": {
        "id": "reports_advancementFilter",
        "eventName": "com_adiantamento",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": 0
    },
    "reports_hoverAdvancement": {
        "id": "reports_hoverAdvancement",
        "eventName": "hover_adiantamento",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Filtro lateral Relatorio",
        "eventValue": 0
    },
    "reports_dateTableFilter": {
        "id": "reports_dateTableFilter",
        "eventName": "data",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Relatório | filtro",
        "eventValue": 0
    },
    "reports_titleTableFilter": {
        "id": "reports_titleTableFilter",
        "eventName": "titulo",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Relatório | filtro",
        "eventValue": 0
    },
    "reports_typeTableFilter": {
        "id": "reports_typeTableFilter",
        "eventName": "tipo",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Relatório | filtro",
        "eventValue": 0
    },
    "reports_reportsTableFilter": {
        "id": "reports_reportsTableFilter",
        "eventName": "relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "reports_statusTableFilter": {
        "id": "reports_statusTableFilter",
        "eventName": "status",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "reports_valueTableFilter": {
        "id": "reports_valueTableFilter",
        "eventName": "valor",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Despesas | filtro",
        "eventValue": 0
    },
    "reports_actionsTableItem": {
        "id": "reports_actionsTableItem",
        "eventName": "acoes_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Tabela Relatorio",
        "eventValue": "{{label}}"
    },
    "reports_openExpense": {
        "id": "reports_openExpense",
        "eventName": "abrir_despesa",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da relatório",
        "eventValue": 0
    },
    "reports_actions": {
        "id": "reports_actions",
        "eventName": "acoes",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba da relatório",
        "eventValue": 0
    },
    "reportsEdit_description": {
        "id": "reportsEdit_description",
        "eventName": "descricao",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": 0
    },
    "reportsEdit_costCenter": {
        "id": "reportsEdit_costCenter",
        "eventName": "centro_custo",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": "{{label}}"
    },
    "reportsEdit_advance": {
        "id": "reportsEdit_advance",
        "eventName": "adiantamento",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": "{{label}}"
    },
    "reportsEdit_project": {
        "id": "reportsEdit_project",
        "eventName": "projeto",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": "{{label}}"
    },
    "reportsEdit_payment": {
        "id": "reportsEdit_payment",
        "eventName": "forma_pagamento",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": "{{label}}"
    },
    "reportsEdit_observation": {
        "id": "reportsEdit_observation",
        "eventName": "obsercacao",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": 0
    },
    "reportsEdit_saveReport": {
        "id": "reportsEdit_saveReport",
        "eventName": "salvar_relatorio",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": 0
    },
    "reportsEdit_saveReportError": {
        "id": "reportsEdit_saveReportError",
        "eventName": "salvar_relatorio_erro",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Editar relatorio",
        "eventValue": 0
    },
    "-reports_sendToApproval": {
        "id": "reports_sendToApproval",
        "eventName": "enviar_aprovacao",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba de relatorios",
        "eventValue": 0
    },
    "-reports_cancelSendToApproval": {
        "id": "reports_cancelSendToApproval",
        "eventName": "cancelar_enviar_aprovacao",
        "eventProduct": "relatorios",
        "eventCategory": "prestação de contas",
        "eventAction": "Aba de relatorios",
        "eventValue": 0
    },
    "-reports_goBackToOldVersion": {
        "id": "reports_goBackToOldVersion",
        "eventName": "vex_relatorios_lista_versao_nova",
        "screenName": "relatorios",
        "eventAction": "click",
        "eventValue": 0
    }
}
